import React, { memo } from 'react'
import SmartphoneMessagingIcon from 'transfix-icons/build/SmartphoneMessagingIcon'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'

interface IUnassignedDriverStatusRow {
  onClick?: (name?: string, elementId?: string) => void
}

export const UnassignedDriverStatusRow = memo<IUnassignedDriverStatusRow>(({ onClick }) => {
  const onClickHandler = () => {
    if (onClick) onClick('load-assignment', '.load-assignment')
  }

  return (
    <Box display='flex'>
      <div className='flex-shrink mt1 items-center'>
        <SmartphoneMessagingIcon size='large' color='coolGray5' />
      </div>
      <div className='subscribers-row-driver-text'>
        <Button onClick={onClickHandler} className='btn-text-link-b' color='primary'>
          Assign a driver
        </Button>{' '}
        to get status updates from your driver
      </div>
    </Box>
  )
})
